import tw from 'twin.macro';
import styled from 'styled-components';

export const Container = styled.div`
  ${tw`flex flex-col items-center w-full`}

`;

export const ImageContainer = styled.div`
  ${tw`relative w-full h-screen mt-0 overflow-hidden flex items-center`}
  padding: 100px 20px;
`;

export const BackgroundImage = styled.img`
  ${tw`absolute top-0 left-0 w-full h-full object-cover`}
  filter: grayscale(0%);
`;

export const Title = styled.h1`
  ${tw`text-6xl text-center font-serif mx-auto`}
  font-family: 'Cantata One', serif;
`;

export const SubTitle = styled.p`
  ${tw`text-2xl ml-auto sm:ml-6 mt-8 space-y-4 text-center font-medium`}
`

export const ContentOverlay = styled.div`
    ${tw`relative z-10 mx-auto text-white p-5`}
`;


export const TextSection = tw.div`p-6 sm:p-28 text-base font-semibold text-gray-700 space-y-6 leading-relaxed`;
